import { Grid } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import React, { memo } from 'react';
import styled from 'styled-components';
import { MuiInput } from './mui-input';

const Root = styled.div`
  padding-left: 10px;
`;

interface Props {
  value: string;
  placeholder: string;
  onInput: (value: string) => void;
}

export const SearchBar = memo(({ value, placeholder, onInput }: Props) => (
  <Root>
    <Grid container spacing={1} alignItems='flex-end'>
      <Grid item>
        <SearchIcon />
      </Grid>
      <Grid item>
        <MuiInput label={placeholder} value={value} onInput={onInput} />
      </Grid>
    </Grid>
  </Root>
));

SearchBar.displayName = 'SearchBar';
